<form [formGroup]="form" (submit)="submit()">
  <mat-card>
    <mat-card-title>
      Bericht von Termin mit
      <a [routerLink]="['/customer', report?.appointment.site?.customer.id]">{{ report?.appointment.site.fullName}}</a>
    </mat-card-title>
    <mat-card-subtitle>
      <p>
        <mat-icon>date_range</mat-icon>
        Datum: {{ report?.appointment.date_time | date }}
      </p>
      <p></p>
      <p *ngIf="report.reminder && !editMode">
        <mat-icon>notifications</mat-icon>
        Erinnerung: <strong>{{ report.reminder | date }}</strong>
      </p>
      <p>
        <mat-icon>{{report?.appointment.on_site ? 'business': 'call'}}</mat-icon>
        {{ report?.appointment.on_site ? 'Vor ort' : 'telefonisch'}}
      </p>
      <p *ngIf="report?.important">
        <mat-icon>whatshot</mat-icon>
        <strong>Objekt</strong>
      </p>
      <p *ngIf="report?.todo">
        <mat-icon>info</mat-icon>
        <strong>zu Erledigen</strong>
      </p>
      <p *ngIf="report?.location">
        <mat-icon>location_city</mat-icon>
        {{ report.location}}
      </p>

    </mat-card-subtitle>
    <mat-card-content>
      <p *ngIf="!editMode">Erstellt am <strong>{{ report.created_at | date }}</strong><span
        *ngIf="report.modified">, Aktualisiert am <strong>{{ report.updated_at | date }}</strong></span>
      </p>
      <mat-slide-toggle formControlName="reminderEnabled" *ngIf="editMode">
        Erinnerung aktiviert
      </mat-slide-toggle>

      <mat-form-field validationInput *ngIf="form.controls['reminderEnabled'].value && editMode">
        <input matInput placeholder="Erinnerung" formControlName="reminder" type="datetime-local" />
      </mat-form-field>
      <div>
        <mat-checkbox formControlName="important" *ngIf="editMode">
          Objekt
        </mat-checkbox>
      </div>

      <div>
        <mat-checkbox formControlName="todo" *ngIf="editMode">
          zu Erledigen
        </mat-checkbox>
      </div>


      <h3 *ngIf="!editMode">{{ report.subject}}</h3>
      <div *ngIf="editMode">
        <div>
          <mat-form-field validationInput>
            <input matInput formControlName="subject" placeholder="Betreff" />
          </mat-form-field>
          <mat-form-field validationInput>
            <input matInput formControlName="location" placeholder="Ort (optional)" />
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="!editMode">{{ report.description }}</div>
      <mat-form-field *ngIf="editMode" class="textarea-control">
        <textarea matInput formControlName="description"
                  placeholder="Beschreibung">{{ report.description }}</textarea>
      </mat-form-field>

    </mat-card-content>
    <mat-card-actions>
      <button *ngIf="!editMode" mat-raised-button (click)="enableEditMode()" type="button">
        Bearbeiten
      </button>
      <button *ngIf="report.reminder != null" type="button" mat-raised-button (click)="markAsDone()">
        <mat-icon>done</mat-icon>
        Abschließen
      </button>
      <button *ngIf="editMode" type="submit" mat-raised-button color="primary">
        Speichern
      </button>
      <button *ngIf="!editMode" type="button" mat-raised-button color="warn" (click)="deleteReport()">
        Löschen
      </button>
    </mat-card-actions>
  </mat-card>
</form>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/report/report-detail/report-detail.component.html